export default function MerryChristmas() {
  return (
    <div>
      <h1>Toivottaa Hyvää Joulua!</h1>
    </div>
  );
}
